import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { registerSW } from 'virtual:pwa-register'
import { initializeAuth } from '@ck/auth'
import { ApiError } from '@ck/api-client'
import '@ck/ui/tokens.css'
import App from './App.vue'
import router from './router'

// ApiError já veio de uma resposta HTTP do servidor e não deve ser repetida; falhas de
// transporte (ex.: QUIC caindo no meio do stream) são transitórias e merecem nova tentativa.
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: (failureCount, error) => failureCount < 2 && !(error instanceof ApiError) } }
})

registerSW({ immediate: true })
await initializeAuth()
createApp(App).use(createPinia()).use(VueQueryPlugin, { queryClient }).use(router).mount('#app')
